module.exports = __webpack_public_path__ + "static/img/log2.e8bea37e.jpg";